import { UserInfoEntity } from "@/domain/entity/user/user-info-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchWebUserInfoUsecase {
  constructor(private readonly userRepo: UserRepository) {}

  async execute(): Promise<SATResult<UserInfoEntity, SATError>> {
    return this.userRepo.fetchWebUserInfo();
  }
}
